import { useCallback } from 'react';
import { useToggle } from '@dfl/hook-utils';
import { useParamsLink } from '@dfl/react-security';
import { useNavigate } from 'react-router';
import { useDeleteClient } from './useDeleteClient';

const useClientMenuOptions = (rowId: string | undefined) => {
  const navigate = useNavigate();

  const { isOpen, onClose, onOpen } = useToggle();
  const { mutate, isLoading, error } = useDeleteClient(rowId || '', onClose);

  const handleConfirm = useCallback(() => {
    mutate();
  }, [mutate]);

  const handleEdit = useParamsLink({ edit: rowId });
  const handleDetails = () => {
    if (rowId) {
      navigate(`/client/${rowId}/general`);
    }
  };

  return {
    handleEdit,
    handleDetails,
    handleConfirm,
    isLoading,
    error,
    isOpen,
    onClose,
    onOpen,
  };
};

export default useClientMenuOptions;
